(function initAhpModal() {
  const bannerModal = document.querySelector(".ahp-banner-modal");

  const identifyCookiesSet = (iso) => {
    const cookieName = `ve-country-${iso}`;

    // Find cookie
    const raw = document.cookie
      .split("; ")
      .find((row) => row.startsWith(cookieName));

    if (!raw) return false;

    // Extract encoded value
    const encodedValue = raw.split("=")[1];

    // Decode URL-encoded query-like string
    const decoded = decodeURIComponent(encodedValue);

    // Convert to object (like query params)
    const params = {};
    decoded.split("&").forEach((part) => {
      const [key, value] = part.split("=");
      params[key] = value;
    });

    if (params.disclaimer === "true") {
      // VANILLA JS REPLACEMENT FOR $("body").addClass("ahp-set");
      document.body.classList.add("ahp-set");
    }
  };

  const dropdownCountryContainer = document.querySelector(
    ".ahp-ucits-dropdown.dropdown-menu .ahp-ucits-dropdown-items-container",
  );

  const dropdownItems =
    dropdownCountryContainer?.querySelectorAll(".dropdown-item");

  var excludeParameters = [
    "country",
    "country2",
    "audience",
    "paudience",
    "disclaimer",
    "abp",
    "abp2",
    "iif",
    "cleardlcookie",
    "defaultaudience",
    "pagena",
    "clearprevurl",
    "prevurl",
    "vehicle",
  ];

  var selectors = {
    ahpHeader: "investor-modal-content-header",
    hiddenSelectedCountry: "input#hdnSelectedCountry",
    hiddenSelectedInvestorType: "input#hdnSelectedAudience",
    hiddenCountryUrl: "input#hdnCountryUrl",
    dataUrlSelector: "input#hdnDataUrl",
    getCountriesUrlSelector: "input#hdnGetCountriesUrl",
    ahpLanguageBtn: ".investor-modal-content-header__language-link",
    countries: ".ahp-modal-countries",
    countrySelectClick: `.investor-modal-content-choose-investor-form .ahp-modal-countries button`,
    countryLabel: `.investor-modal-content-choose-investor-form span.country_label`,
    investorTypeButton: `.investor-modal-content-choose-investor-form span.investortype_label`,
    investorTypeSelectClick:
      "div.investor-modal-content-choose-investor-items .investor-modal-content-choose-investor-item",
    investorTypeSelectClickRetail:
      "div.investor-modal-content-choose-investor-items .investor-modal-content-choose-investor-item[id=retail]",
    investorTypeContainer: "div.investor-modal-content-choose-investor-items",
    hiddenLanguage: "input#hdnLanguage",
    disclaimerHeader: "#disclaimer-header",
    hiddenCurrentLanguage: "#hdnCurrentLanguage",
    disclaimerSection: "#disclaimer-section",
    disclaimerBlock: "#disclaimer_block",
    disclaimerBlockHeader: "#disclaimer_block .header",
    termsBlockText:
      "#disclaimer_block .investor-modal-content-choose-investor__terms",
    disclaimerBlockText:
      "#disclaimer_block .investor-modal-content-choose-investor__disclaimer",
    disclaimerBlockAgree: "#disclaimer_block .agree",
    currentCountryName: "#hdnCurrentCountryName",
    selectCountryText: "#select-country-text",
    selectedCountryName: "#hdnAhpSelectedCountryName",
    ahpLanguageContainer: ".investor-modal-content-header__language-selector",
    siteLanguageSelector:
      "div.gateway div#site-lang-dropdown ul .dropdown-item",
    closeModalButton: ".investor-modal-content-header__close",
    gatewayModal: "#gateway-modal",
    ahpDropdownSearch: ".ahp-ucits-dropdown__search",
    selectedInvestorLabel:
      ".investor-modal-content-choose-investor-items-selected",
  };

  const ahpSearch = document.querySelector(`${selectors.ahpDropdownSearch}`);

  function initialCookieCheck() {
    const pathParts = window.location.pathname.split("/").filter(Boolean);
    if (pathParts.length > 0) {
      const countryIso = pathParts[0];
      identifyCookiesSet(countryIso);

      if (bannerModal && bannerModal.classList.contains("show")) {
        document.body.classList.add("ahp-banner-opened");
      } else {
        document.body.classList.remove("ahp-banner-opened");
      }
    }
  }

  initialCookieCheck();

  const sitecountries = [
    "United States",
    "Australia",
    "Brazil",
    "Canada",
    "Chile",
    "China",
    "Peru",
    "Rest of Asia",
    "Rest of World",
  ];

  const actionMethods = {
    getInvestorAndLanguages: "getinvestorandlanguages",
    getTranslations: "gettranslations",
    getDisclaimer: "getdisclaimer",
  };

  const getInvestorIcon = (key) => {
    switch (key) {
      case "retail":
        return `
        <svg
          fill="currentColor"
          class="investor-modal-content-choose-investor__icon"
          width="60"
          height="60"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 640 640"
        >
          <path d="M320 312C386.3 312 440 258.3 440 192C440 125.7 386.3 72 320 72C253.7 72 200 125.7 200 192C200 258.3 253.7 312 320 312zM290.3 368C191.8 368 112 447.8 112 546.3C112 562.7 125.3 576 141.7 576L498.3 576C514.7 576 528 562.7 528 546.3C528 447.8 448.2 368 349.7 368L290.3 368z" />
        </svg>
      `;

      default:
        return `<svg
          fill="currentColor"
          class="investor-modal-content-choose-investor__icon"
          width="60"
          height="60"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 640 640"
        >
          <path d="M64 128C64 92.7 92.7 64 128 64L384 64C419.3 64 448 92.7 448 128L448 249.3C401.1 268.3 368 314.3 368 368C368 395.7 376.8 421.4 391.8 442.4C340.3 463.4 304 514 304 573.1C304 574.1 304 575 304 576L128 576C92.7 576 64 547.3 64 512L64 128zM208 464L208 528L261.4 528C268.6 498.6 282.7 471.9 301.8 449.7C295.7 430.2 277.5 416 256 416C229.5 416 208 437.5 208 464zM339 288.3C338 288.1 337 288 336 288L304 288C295.2 288 288 295.2 288 304L288 336C288 344.8 295.2 352 304 352L320.7 352C322.8 329.2 329.1 307.7 339 288.3zM176 160C167.2 160 160 167.2 160 176L160 208C160 216.8 167.2 224 176 224L208 224C216.8 224 224 216.8 224 208L224 176C224 167.2 216.8 160 208 160L176 160zM288 176L288 208C288 216.8 295.2 224 304 224L336 224C344.8 224 352 216.8 352 208L352 176C352 167.2 344.8 160 336 160L304 160C295.2 160 288 167.2 288 176zM176 288C167.2 288 160 295.2 160 304L160 336C160 344.8 167.2 352 176 352L208 352C216.8 352 224 344.8 224 336L224 304C224 295.2 216.8 288 208 288L176 288zM416 368C416 323.8 451.8 288 496 288C540.2 288 576 323.8 576 368C576 412.2 540.2 448 496 448C451.8 448 416 412.2 416 368zM352 576C352 523 395 480 448 480L544 480C597 480 640 523 640 576C640 593.7 625.7 608 608 608L384 608C366.3 608 352 593.7 352 576z" />
        </svg>
      `;
    }
  };

  function doClickEvent(url, target) {
    if (!url) return false;
    var decodedUrl = decodeURIComponent(url);
    if (!target || target === "") {
      target = "_self";
    }
    // Corrected target assignment (window.location does not have a 'target' property)
    // If you intended to change how the window opens:
    var parentUrl = window.location.toString();
    if (parentUrl.includes("#")) {
      decodedUrl = decodedUrl + "#" + parentUrl.split("#")[1];
    }

    if (target === "_blank") {
      window.open(decodeURIComponent(decodedUrl), "_blank");
    } else {
      window.location.href = decodeURIComponent(decodedUrl);
    }
    return false;
  }

  const acceptClickEvent = function (url, target) {
    doClickEvent(url, target);
  };

  // Vanilla check for String.prototype.endsWith is built-in now,
  // but keeping your logic as requested.
  const endsWith = function (str, suffix) {
    if (!str || !suffix) return false;
    return str.indexOf(suffix, str.length - suffix.length) !== -1;
  };

  const removeUrlParameter = function (url, parameter) {
    var urlParts = url.split("?");
    if (urlParts.length >= 2) {
      var urlBase = urlParts.shift();
      var queryString = urlParts.join("?");
      var prefix = encodeURIComponent(parameter) + "=";
      var parts = queryString.split(/[&;]/g);
      for (var i = parts.length; i-- > 0; ) {
        if (parts[i].lastIndexOf(prefix, 0) !== -1) {
          parts.splice(i, 1);
        }
      }
      url = urlBase + (parts.length > 0 ? "?" + parts.join("&") : "");
    }
    return url;
  };

  function decodeHtml(html) {
    if (typeof html !== "string") return String(html || "");
    if (typeof DOMParser === "undefined") return html;
    return new DOMParser().parseFromString(html, "text/html").documentElement
      .textContent;
  }

  const onAgree = (e) =>
    acceptClickEvent(e.currentTarget.getAttribute("data-agree"), "_self");

  const investorTypeSelection = function (
    currentElement, // Expecting a native DOM element now
    action,
    selectedCountry,
    returnUrl,
    currentUrl,
    defaultDeepLinkSession,
    language,
    countryName,
  ) {
    // Guards for required elements
    const hiddenAudience = document.querySelector(
      selectors.hiddenSelectedInvestorType,
    );
    const disclaimerBlockHeader = document.querySelector(
      selectors.disclaimerBlockHeader,
    );
    const termsBlockText = document.querySelector(selectors.termsBlockText);
    const disclaimerBlockText = document.querySelector(
      selectors.disclaimerBlockText,
    );
    const disclaimerBlockAgree = document.querySelector(
      selectors.disclaimerBlockAgree,
    );
    const disclaimerBlock = document.querySelector(selectors.disclaimerBlock);

    // VANILLA JS: currentElement.id instead of .attr("id")
    if (hiddenAudience) {
      hiddenAudience.value = currentElement.id;
    }

    var disclaimerJson = getData(
      action,
      hiddenAudience ? hiddenAudience.value : "",
      selectedCountry,
      returnUrl,
      currentUrl,
      language,
      defaultDeepLinkSession,
      countryName,
    );

    // VANILLA JS: Promise handling (replaces .done)
    disclaimerJson.then(function (data) {
      if (
        (data.Text !== null && data.Text !== "") ||
        (data.IntroText !== null && data.IntroText !== "")
      ) {
        if (disclaimerBlockHeader)
          disclaimerBlockHeader.innerHTML = data.Header;
        if (termsBlockText) termsBlockText.style.display = "block";
        if (disclaimerBlockText) disclaimerBlockText.style.display = "block";
      } else {
        if (disclaimerBlockHeader) disclaimerBlockHeader.innerHTML = "";
        if (termsBlockText) termsBlockText.style.display = "none";
        if (disclaimerBlockText) disclaimerBlockText.style.display = "none";
      }

      const decodedAgreeText = data.AgreeUcitsText
        ? decodeHtml(data.AgreeUcitsText)
        : decodeHtml(data.AgreeText);

      if (termsBlockText) termsBlockText.innerHTML = data.Text;
      if (disclaimerBlockText) disclaimerBlockText.innerHTML = data.IntroText;

      if (disclaimerBlockAgree) {
        disclaimerBlockAgree.setAttribute("data-agree", data.AcceptUrl);
        disclaimerBlockAgree.textContent = decodedAgreeText;

        // VANILLA JS: Event listener (Note: using 'onclick' or 'addEventListener')
        // We use addEventListener to avoid overwriting other potential logic

        disclaimerBlockAgree.removeEventListener("click", onAgree);
        disclaimerBlockAgree.addEventListener("click", onAgree);

        // enable the agree button
        disclaimerBlockAgree.removeAttribute("disabled");
      }

      if (disclaimerBlock) {
        if (sitecountries.includes(countryName)) {
          disclaimerBlock.classList.remove("disclaimer-eu");
        } else {
          disclaimerBlock.classList.add("disclaimer-eu");
        }
        disclaimerBlock.style.display = "block";
      }

      if (data.SearchCountryHint) {
        ahpSearch?.setAttribute("placeholder", data.SearchCountryHint);
      }
    });
  };

  const removeUrlParameters = function (url) {
    var returnUrl = "";
    // VANILLA JS: Array.forEach replaces $.each
    excludeParameters.forEach(function (value) {
      if (returnUrl !== "") {
        returnUrl = removeUrlParameter(returnUrl, value);
      } else {
        returnUrl = removeUrlParameter(url, value);
      }
    });

    if (endsWith(returnUrl, "?") || endsWith(returnUrl, "&")) {
      returnUrl = returnUrl.slice(0, -1);
    }
    return returnUrl;
  };

  const getData = async function (
    action,
    param1,
    param2,
    param3,
    param4,
    param5,
    param6,
    param7,
  ) {
    const dataUrlEl = document.querySelector(selectors.dataUrlSelector);
    if (!dataUrlEl) return;

    // Create URL with Search Params
    const url = new URL(dataUrlEl.value, window.location.origin);
    const params = {
      op: action,
      param1,
      param2,
      param3,
      param4,
      param5,
      param6,
      param7,
      // cache: false equivalent in vanilla is usually adding a timestamp or using cache headers
      _t: Date.now(),
    };

    Object.keys(params).forEach((key) => {
      if (params[key] !== undefined) url.searchParams.append(key, params[key]);
    });

    // VANILLA JS: fetch() replaces $.ajax
    const response = await fetch(url, {
      method: "GET",
      cache: "no-store", // Disables caching
    });

    return await response.json();
  };

  const reorderCountryDropdown = async function (languageIso) {
    const urlEl = document.querySelector(selectors.getCountriesUrlSelector);
    if (!urlEl || !languageIso) return;

    const url = new URL(urlEl.value, window.location.origin);
    url.searchParams.append("languageIso", languageIso);
    url.searchParams.append("_t", Date.now());

    const response = await fetch(url, { method: "GET", cache: "no-store" });
    if (!response.ok) {
        console.warn("GetCountries failed", response.status);
        return;
    }

    const orderedCountries = await response.json();
    if (!orderedCountries || !orderedCountries.length) {
        console.warn("GetCountries returns an empty result");
        return;
    }

    const containers = document.querySelectorAll(
      ".ahp-ucits-dropdown-items-container, div.countries",
    );
    containers.forEach((container) => {
      orderedCountries.forEach((country) => {
        const btn = container.querySelector(
          `button[data-id="${country.Iso}"]`,
        );
        if (btn) container.appendChild(btn);
      });
    });
  };

  const investorTypeButtonClick = function (currentElement, countryName) {
    var currentUrl = encodeURIComponent(
      removeUrlParameters(window.location.pathname + window.location.search),
    );

    const investorTypes = document.querySelectorAll(
      selectors.investorTypeSelectClick,
    );

    // VANILLA JS: removeClass from multiple elements
    investorTypes.forEach((el) => {
      el.classList.remove("active");
    });

    // VANILLA JS: currentElement is native now
    currentElement.classList.add("active");
    const selectedInvestorLabel = document.querySelector(
      selectors.selectedInvestorLabel,
    );

    if (selectedInvestorLabel && currentElement) {
      selectedInvestorLabel.textContent = currentElement.textContent;
    }

    var defaultDeepLinkSession = "";
    if (document.body.classList.contains("disclaimer-deeplink")) {
      defaultDeepLinkSession = "true";
    }

    const hiddenCountry = document.querySelector(
      selectors.hiddenSelectedCountry,
    );
    const hiddenLang = document.querySelector(selectors.hiddenLanguage);

    investorTypeSelection(
      currentElement,
      actionMethods.getDisclaimer,
      hiddenCountry ? hiddenCountry.value : "",
      "",
      currentUrl,
      defaultDeepLinkSession,
      hiddenLang ? hiddenLang.value : "",
      countryName,
    );
  };

  const resetSearchTerm = () => {
    if (!dropdownItems || !ahpSearch) return;
    dropdownItems.forEach((item) => {
      item.style.display = "";
    });

    ahpSearch.value = "";
  };

  const handleClickOutsideSelect = (e) => {
    if (!ahpSearch) return;
    const select = e.target.closest(
      ".investor-modal-content-choose-investor__select-country",
    );
    if (!select && ahpSearch.value.length) {
      resetSearchTerm();
    }
  };

  document.addEventListener("click", handleClickOutsideSelect);

  const autoselectInvidualInvestor = function () {
    const hiddenAudience = document.querySelector(
      selectors.hiddenSelectedInvestorType,
    );
    const agreeBtn = document.querySelector(selectors.disclaimerBlockAgree);
    const retailBtn = document.querySelector(
      selectors.investorTypeSelectClickRetail,
    );

    // See if no investor type has been selected
    if (hiddenAudience && hiddenAudience.value === "") {
      // Temporarily disable the accept button
      if (agreeBtn) agreeBtn.setAttribute("disabled", "disabled");

      // VANILLA JS: Trigger a click
      if (retailBtn) retailBtn.click();

      // Focus on the agree button
      if (agreeBtn) agreeBtn.focus();

      const modal = document.querySelector(selectors.gatewayModal);
      const target = document.querySelector(".scroll-to-investor");

      // VANILLA JS: scroll handles replaced $modal.animate
      if (modal && target) {
        const targetTop = target.getBoundingClientRect().top + modal.scrollTop;
        const modalTop = modal.getBoundingClientRect().top;
        const scrollTop = targetTop - modalTop;

        modal.scrollTo({
          top: scrollTop,
          behavior: "smooth",
        });
      }
    }
  };

  const selectCountry = function (e) {
    // VANILLA JS: 'this' refers to the element that triggered the listener
    const countryName = this.getAttribute("data-name") || "";
    const blockId = this.getAttribute("data-blockid");
    const countryId = this.getAttribute("data-id");

    const selectedCountryNameEl = document.querySelector(
      selectors.selectedCountryName,
    );
    if (selectedCountryNameEl) selectedCountryNameEl.value = countryName;

    const flagName =
      "investor-modal-content-choose-investor__select-country dropdown mb-4 global-nav-flag country-" +
      countryName.toLowerCase().replace(/\s+/g, "-");

    // VANILLA JS: .className overwrites all classes, matching .removeClass().addClass()
    const flagContainer = document.querySelector(
      ".investor-modal-content-choose-investor__select-country",
    );
    if (flagContainer) {
      flagContainer.className = flagName;
    }

    const hiddenSelectedCountry = document.querySelector(
      selectors.hiddenSelectedCountry,
    );
    if (hiddenSelectedCountry) hiddenSelectedCountry.value = countryId;

    const countryLabel = document.querySelector(selectors.countryLabel);
    if (countryLabel) countryLabel.innerHTML = e.target.innerText.trim();

    const hiddenLanguageEl = document.querySelector(selectors.hiddenLanguage);
    const hiddenLanguage = hiddenLanguageEl ? hiddenLanguageEl.value : "";

    const currentUrl = encodeURIComponent(
      removeUrlParameters(window.location.pathname + window.location.search),
    );

    const jsonData = getData(
      actionMethods.getInvestorAndLanguages,
      blockId,
      hiddenLanguage,
      countryId,
      currentUrl,
    );

    const disclaimerBlock = document.querySelector(selectors.disclaimerBlock);
    if (disclaimerBlock) disclaimerBlock.style.display = "none";

    // Assuming getData is an async function from previous chunk
    jsonData.then(function (json) {
      if (json.InvestorType !== null) {
        let investorHtml = `<span class="investor-modal-content-choose-investor-items-selected sr-only" data-ve-gtm="ahp-investor-type">${json?.SelectInvestorText ?? ""}</span>`;
        // VANILLA JS: Object.entries for looping through object
        Object.entries(json.InvestorType).forEach(([key, value]) => {
          const icon = getInvestorIcon(key);
          investorHtml += `
                      <button 
                        id="${key}" 
                        class="investor-modal-content-choose-investor-item content-item-t ${
                          key === "retail" ? "active" : ""
                        }" 
                        role="menuitem" 
                        type="button" 
                        value="${value}"
                      >
                        ${icon}
                        <span class="investor-modal-content-choose-investor__text investortype_label">${value}</span>
                      </button>`;
        });
        const investorContainer = document.querySelector(
          selectors.investorTypeContainer,
        );
        if (investorContainer) investorContainer.innerHTML = investorHtml;
      }

      if (json.Languages !== null) {
        let languageHtml = "";
        const languageEntries = Object.entries(json.Languages);

        if (languageEntries.length > 1) {
          languageEntries.forEach(([key, _value]) => {
            const lang = key.split("-")[0];
            languageHtml += `
              <button class="investor-modal-content-header__language-link" data-id="${key}">
                ${lang}
              </button>`;
          });
        }

        const langContainer = document.querySelector(
          selectors.ahpLanguageContainer,
        );

        if (langContainer) langContainer.innerHTML = languageHtml;
      }

      resetSearchTerm();

      const countriesList = document.querySelector(selectors.countries);
      if (countriesList) countriesList.classList.remove("show");

      // Re-binding investor type buttons
      const investorButtons = document.querySelectorAll(
        selectors.investorTypeSelectClick,
      );

      investorButtons.forEach((btn) => {
        btn.addEventListener("click", function (e) {
          investorTypeButtonClick(this, countryName);
        });
      });

      const hiddenAudience = document.querySelector(
        selectors.hiddenSelectedInvestorType,
      );
      if (hiddenAudience) hiddenAudience.value = "";

      investorButtons.forEach((el) => el.classList.remove("active"));

      autoselectInvidualInvestor();
    });

    return false;
  };

  const countrySelectorBtns = document.querySelectorAll(
    selectors.countrySelectClick,
  );
  const investorSelectorBtns = document.querySelectorAll(
    selectors.investorTypeSelectClick,
  );

  countrySelectorBtns.forEach((btn) => {
    btn.addEventListener("click", selectCountry);
  });

  investorSelectorBtns.forEach((btn) => {
    btn.addEventListener("click", function (e) {
      const currentCountryInput = document.querySelector(
        selectors.currentCountryName,
      );
      investorTypeButtonClick(
        this,
        currentCountryInput ? currentCountryInput.value : "",
      );
    });
  });

  const agreeBtn = document.querySelector(selectors.disclaimerBlockAgree);
  if (agreeBtn) {
    agreeBtn.removeEventListener("click", onAgree);
    agreeBtn.addEventListener("click", onAgree);
  }

  const changeAhpLanguage = function (lang) {
    var target = lang; // Assuming lang is a native DOM element

    var hiddenLanguageEl = document.querySelector(selectors.hiddenLanguage);
    var oldLanguageIso = hiddenLanguageEl ? hiddenLanguageEl.value : "";

    if (hiddenLanguageEl) {
      hiddenLanguageEl.value = target.getAttribute("data-id");
    }

    var audienceType = document.querySelector(
      selectors.hiddenSelectedInvestorType,
    )?.value;
    var countryIso = document.querySelector(
      selectors.hiddenSelectedCountry,
    )?.value;
    var countryName = "";
    var countryUrl = document.querySelector(selectors.hiddenCountryUrl)?.value;

    var disclaimerHeaders = document.querySelectorAll(
      selectors.disclaimerHeader,
    );
    if (disclaimerHeaders.length > 1) {
      var header = disclaimerHeaders[0]; // Assuming first one if multiple
      audienceType = header.getAttribute("data-audience");
      countryIso = header.getAttribute("data-countryiso");
      countryName = header.getAttribute("data-countryname");
      countryUrl = header.getAttribute("data-accepturl");
    } else {
      audienceType = document.querySelector(
        selectors.hiddenSelectedInvestorType,
      )?.value;
      countryIso = document.querySelector(
        selectors.hiddenSelectedCountry,
      )?.value;
      countryName = document.querySelector(
        selectors.selectedCountryName,
      )?.value;
      countryUrl = document.querySelector(selectors.hiddenCountryUrl)?.value;
    }

    var defaultDeepLinkSession = "";
    if (document.body.classList.contains("disclaimer-deeplink")) {
      defaultDeepLinkSession = "true";
    }

    var countryLabelEl = document.querySelector(selectors.countryLabel);
    var selectedCountryName = countryLabelEl
      ? countryLabelEl.innerHTML.trim()
      : "";

    countryName = document.querySelector(selectors.selectedCountryName)?.value;
    if (!countryName || countryName == "") {
      countryName = document.querySelector(selectors.currentCountryName)?.value;
    }

    var currentUrl = encodeURIComponent(
      removeUrlParameters(window.location.pathname + window.location.search),
    );

    var translations = getData(
      actionMethods.getTranslations,
      target.getAttribute("data-id"),
      audienceType,
      countryIso,
      currentUrl,
      countryName,
      oldLanguageIso,
      defaultDeepLinkSession,
    );

    // Replaces .done()
    translations.then(function (translation) {
      if (translation.List) {
        translation.List.forEach(function (value) {
          const contentItems = document.querySelectorAll(".content-item-t");
          contentItems.forEach(function (item) {
            var regex = new RegExp(value.Text, "g");
            item.innerHTML = item.innerHTML.replace(
              regex,
              value.TranslatedText,
            );
          });
        });
      }

      const freshCountryLabelEl = document.querySelector(
        selectors.countryLabel,
      );

      if (translation.List) {
        for (var i = 0; i < translation.List.length; i++) {
          if (
            translation.List[i].Text.trim().toLowerCase() ==
            selectedCountryName.trim().toLowerCase()
          ) {
            if (freshCountryLabelEl) {
              freshCountryLabelEl.innerHTML =
                translation.List[i].TranslatedText.trim();
            }
            break;
          }
        }
      }

      const decodedAgreeText = translation.AgreeUcitsText
        ? decodeHtml(translation.AgreeUcitsText)
        : decodeHtml(translation.AgreeText);

      const termsBlock = document.querySelector(selectors.termsBlockText);
      const disclaimerBlockText = document.querySelector(
        selectors.disclaimerBlockText,
      );
      const disclaimerHeader = document.querySelector(
        selectors.disclaimerBlockHeader,
      );
      const agreeButton = document.querySelector(
        selectors.disclaimerBlockAgree,
      );

      const hasTermsHtml = termsBlock
        ? termsBlock.innerHTML.trim().length > 1
        : false;
      const hasDisclaimerHtml = disclaimerBlockText
        ? disclaimerBlockText.innerHTML.trim().length > 1
        : false;

      if (hasTermsHtml || hasDisclaimerHtml) {
        if (
          (translation.Text !== null && translation.Text !== "") ||
          (translation.IntroText !== null && translation.IntroText !== "")
        ) {
          if (disclaimerHeader) disclaimerHeader.innerHTML = translation.Header;
          if (termsBlock) {
            termsBlock.innerHTML = translation.Text;
            termsBlock.style.display = "block";
          }
          if (disclaimerBlockText) {
            disclaimerBlockText.innerHTML = translation.IntroText;
            disclaimerBlockText.style.display = "block";
          }
          if (agreeButton) {
            agreeButton.setAttribute("data-agree", translation.AcceptUrl);
            agreeButton.textContent = decodedAgreeText;
          }
        } else {
          if (termsBlock) termsBlock.style.display = "none";
          if (disclaimerBlockText) disclaimerBlockText.style.display = "none";
          if (agreeButton) {
            agreeButton.setAttribute("data-agree", translation.AcceptUrl);
            agreeButton.textContent = decodedAgreeText;
          }
        }
      }

      if (translation.SearchCountryHint) {
        ahpSearch?.setAttribute("placeholder", translation.SearchCountryHint);
      }

      // Bind event listener to the single agree button
      if (agreeButton) {
        agreeButton.onclick = function (e) {
          acceptClickEvent(this.getAttribute("data-agree"), "_self");
        };
      }

      reorderCountryDropdown(target.getAttribute("data-id"));
    });
  };

  // --- Search Filtering ---
  const searchByCountry = (e) => {
    const searchTerm = e.target.value.toLowerCase();

    dropdownItems.forEach((item) => {
      // Note: using native properties instead of jQuery methods
      const value = (item.value || "").toLowerCase();
      const text = (item.textContent || "").toLowerCase();

      // Logic remains identical to original requirements
      if (
        searchTerm.length >= 2 &&
        !value.startsWith(searchTerm) &&
        !text.startsWith(searchTerm)
      ) {
        item.style.display = "none";
      } else {
        item.style.display = "";
      }
    });
  };

  ahpSearch?.addEventListener("input", searchByCountry);

  // --- Deep Link & Modal Logic ---
  const autoselectInvidualInvestorOnDeepLink = function () {
    const countryLabel = document.querySelector("#select-country-text");
    if (!countryLabel) return;

    const currentCountry = countryLabel.textContent.trim();

    // Logic check: only proceed if the country is NOT in the sitecountries list
    if (sitecountries.includes(currentCountry)) return;

    autoselectInvidualInvestor();
  };

  if (bannerModal && bannerModal.classList.contains("show")) {
    autoselectInvidualInvestorOnDeepLink();
  }

  // Initial check if modal is already shown

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.attributeName === "class") {
        const isVisible = mutation.target.classList.contains("show");
        if (isVisible) {
          autoselectInvidualInvestorOnDeepLink();
          document.body.classList.add("ahp-banner-opened");
        } else {
          document.body.classList.remove("ahp-banner-opened");
        }
      }
    });
  });

  if (bannerModal) {
    bannerModal.addEventListener("show.bs.modal", (event) => {
      autoselectInvidualInvestorOnDeepLink();
    });
    observer.observe(bannerModal, { attributes: true });
  }

  const languageContainer = document.querySelector(
    selectors.ahpLanguageContainer,
  );

  if (languageContainer) {
    languageContainer.addEventListener("click", function (e) {
      // 1. Find the closest element matching the language button selector
      const btn = e.target.closest(selectors.ahpLanguageBtn);

      // 2. If the click wasn't on a language button, ignore it
      if (!btn) return;

      // 3. Remove active class from all buttons within this container
      const allBtns = languageContainer.querySelectorAll(
        selectors.ahpLanguageBtn,
      );
      allBtns.forEach((el) => el.classList.remove("active"));

      // 4. Add active to the clicked button
      btn.classList.add("active");

      // 5. Call function passing the button element
      changeAhpLanguage(btn);
    });
  }
})();
